import { get } from '@core/api/baseApi';
import { GetStudyResponse } from '@core/types';

const getSharedStudy = async (shareHash: string): Promise<GetStudyResponse> =>
  await get(`studies/shared/${shareHash}`);

export default getSharedStudy;
